export const OLO = "OLO";
export const SPEEDLINE = "SPEEDLINE";
export const ADORA = "ADORA";
export const TOAST = "TOAST";
export const PAYTRONIX = "PAYTRONIX";